import { Search } from "@pages:app/talk/Search/Search";
import { TalkLayout } from "@pages:app/talk/TalkLayout";

export const TalkSearch = () => {
  return (
    <TalkLayout>
      <Search />
    </TalkLayout>
  );
};
